import React, {FC} from 'react';
import DynamicAsset from 'components/DynamicAsset';
import {Location} from 'components/TimePicker/types';

import {useBannerImage} from './useBannerImage';

import * as styles from './styles.module.scss';

interface BannerProps {
	location?: Location
}

const Banner: FC<BannerProps> = ({location}) => {
	const image = useBannerImage(location);

	return (
		<div className={styles.banner}>
			<DynamicAsset imageSrc={image} alt='Booking Details' />
		</div>
	);
};

export default Banner;
